import { RestoreableModel, ResourceFactory } from '../services/';

class System extends RestoreableModel {
  public name: string = '';
  public stations_count?: number;
  public campaigns_count?: number;
  public samples_count?: number;
  public results_count?: number;
  public parameters_count?: number;
}

const SystemFactory = ResourceFactory.create<System>(System, 'system');

export { System, SystemFactory };
